import {
    Container,
    VStack,
    Card,
    Button,
    FormControl,
    FormLabel,
    Input,
    HStack,
    Text,
} from '@chakra-ui/react'
import React from 'react'
import { useStoreLocations } from '../../providers/LocationProvider';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function AddLocation() {

    var { addData } = useStoreLocations();
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            name: "",
            username: "",
            password: "",
        },
        onSubmit: async (values) => {
            try {
                // if(values.province.length >= 250){
                //     toast.error("Please Enter less than 250 characters !");
                //     return;
                // }
                await addData(values.name, values.username, values.password);
            } catch (error) {
                console.log("Error Adding !");
            }
        }
    });


    return (
        <Container p='4' maxW='3xl'>
            <VStack width='100%' spacing={4}>

                <Card borderRadius='md' p='4' width={'100%'}>
                    <HStack justifyContent='space-between'>
                        <Text fontWeight='bold' className='customfont' fontSize='2xl'>Add Location</Text>
                    </HStack>
                </Card>

                <Card width={'100%'} p='6'>

                    <form onSubmit={formik.handleSubmit}>
                        <VStack spacing={4} align="flex-start">
                            <FormControl>
                                <FormLabel htmlFor="name">Name</FormLabel>
                                <Input
                                    id="name"
                                    name="name"
                                    type="text"
                                    variant="filled"
                                    required={true}
                                    onChange={formik.handleChange}
                                    value={formik.values.name}
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel htmlFor="username">Username</FormLabel>
                                <Input
                                    id="username"
                                    name="username"
                                    type="text"
                                    variant="filled"
                                    required={true}
                                    onChange={formik.handleChange}
                                    value={formik.values.username}
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel htmlFor="password">Password</FormLabel>
                                <Input
                                    id="password"
                                    name="password"
                                    type="text"
                                    variant="filled"
                                    required={true}
                                    onChange={formik.handleChange}
                                    value={formik.values.password}
                                />
                            </FormControl>

                            <Button type="submit" bg='primary.800' colorScheme="primary" py='6' width="full">
                                Add
                            </Button>


                        </VStack>
                    </form>

                </Card>
            </VStack>
        </Container>
    )
}

